<template>
  <el-dialog
    :title="editId ? '编辑产品' : '添加产品'"
    v-if="value"
    :visible.sync="value"
    width="90%"
    top="5vh"
    :before-close="onClose">
    <upload-pictures
      ref="UploadPicturesRef"
      :upload-action="uploadAction"
      @ImgList="onUploadImgList" />
    <base-info
      ref="BaseInfoRef"
      @categoryAttr="onCategoryAttr"
      @changeShop="onChangeShop" />
    <wuliu ref="WuliuRef" />
    <leimu ref="LeimuRef" :list="categoryAttrList" />
    <laiyuan ref="LaiyuanRef" />
    <bianti ref="BiantiRef" />

    <span
      slot="footer"
      class="dialog-footer"
      v-if="['create', 'edit', 'update'].includes(operateType)">
      <el-button @click="onClose">取消</el-button>
      <el-button
        v-if="['create', 'edit'].includes(operateType)"
        type="primary"
        :loading="loadingStatus"
        @click="onSubmit(1)">
        保存
      </el-button>
      <el-button
        v-if="['create', 'edit'].includes(operateType)"
        type="primary"
        :loading="loadingStatus"
        @click="onSubmit(2)">
        保存并发布
      </el-button>
      <el-button
        v-else-if="['update'].includes(operateType)"
        type="primary"
        :loading="loadingStatus"
        @click="onSubmit(2)">
        保存并更新
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Baseurl, ajaxPost } from '@/api/api/api'

import uploadPictures from './uploadPictures.vue'
import baseInfo from './baseInfo.vue'
import wuliu from './wuliu.vue'
import leimu from './leimu.vue'
import laiyuan from './laiyuan.vue'
import bianti from './bianti.vue'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    uploadPictures,
    baseInfo,
    wuliu,
    leimu,
    laiyuan,
    bianti
  },
  data() {
    return {
      roleInfo: null,
      uploadAction: Baseurl + 'shopeeImage/uploadImage',
      editId: '',
      globalItemId: '', // 更新时用的
      operateType: 'create',
      imgList: [],
      categoryAttrList: [],
      formData: {},
      loadingStatus: false
    }
  },
  computed: {},
  watch: {},
  created() {
    this.roleInfo = JSON.parse(localStorage.getItem('role'))
  },
  methods: {
    onClose() {
      this.$emit('input', false)
    },
    onUploadImgList(list) {
      this.imgList = []
      list.forEach((item) => {
        if (typeof item === 'string') {
          // 上传图片成功后返回的是图片地址，截取file/后面的id
          this.imgList.push(item.split('file/')[1])
          return
        }
      })
    },
    onCategoryAttr(list) {
      this.categoryAttrList = list
      const baseInfo = this.$refs.BaseInfoRef.getFormData()
      this.$refs.WuliuRef.fetchDayInfo(baseInfo.categoryId)
      this.onTellBianti()
    },
    onChangeShop() {
      this.onTellBianti()
    },
    setFormData(data) {
      const {
        id,
        type,
        shopeeGlobalProduct,
        shopeeGlobalProductSkuList,
        shopeeGlobalProductVariation
      } = data

      this.editId = id || ''
      this.operateType = type || ''

      const imgList = JSON.parse(shopeeGlobalProduct.imageIdList).map(
        (key) => `https://s-cf-tw.shopeesz.com/file/${key}`
      )
      this.$refs.UploadPicturesRef.addImgList(imgList)

      this.globalItemId = shopeeGlobalProduct.globalItemId
      const baseInfo = {
        name: shopeeGlobalProduct.globalItemName,
        shop: shopeeGlobalProduct.merchantId,
        categoryName: shopeeGlobalProduct.fullCategoryName,
        categoryId: shopeeGlobalProduct.categoryId,
        sku: shopeeGlobalProduct.globalItemSku,
        desc: shopeeGlobalProduct.description
      }
      this.$refs.BaseInfoRef.setFormData(baseInfo)

      const wuliu = {
        shopStatus: shopeeGlobalProduct.condition,
        day: shopeeGlobalProduct.daysToShip,
        weight: shopeeGlobalProduct.weight,
        width: shopeeGlobalProduct.packageWidth,
        height: shopeeGlobalProduct.packageHeight,
        depth: shopeeGlobalProduct.packageLength
      }
      this.$refs.WuliuRef.setFormData(wuliu)

      const leimu = JSON.parse(shopeeGlobalProduct.attributeList)
      this.$refs.LeimuRef.setFormData(leimu)

      const laiyuan = {
        remark: shopeeGlobalProduct.remark,
        sourceUrl: JSON.parse(shopeeGlobalProduct.sourceUrl)
      }
      this.$refs.LaiyuanRef.setFormData(laiyuan)

      const bianti = {
        isVariant: shopeeGlobalProduct.hasVariant,
        xuanzeList: imgList,
        price: shopeeGlobalProduct.originalPrice,
        stock: shopeeGlobalProduct.stock,
        sku: shopeeGlobalProduct.globalItemSku,
        variantList: shopeeGlobalProductVariation
          ? JSON.parse(shopeeGlobalProductVariation.tierVariation)
          : '',
        guigeTableData: shopeeGlobalProductSkuList || []
      }
      this.$refs.BiantiRef.setFormData(bianti)
    },
    getFormData() {
      const baseInfo = this.$refs.BaseInfoRef.getFormData()
      const wuliu = this.$refs.WuliuRef.getFormData()
      const leimu = this.$refs.LeimuRef.getFormData()
      const laiyuan = this.$refs.LaiyuanRef.getFormData()
      const bianti = this.$refs.BiantiRef.getFormData()
      this.formData = { baseInfo, wuliu, leimu, laiyuan, bianti }
    },
    // 告诉变体组件已经选择了店铺和分类
    onTellBianti() {
      try {
        this.getFormData()
        const { baseInfo } = this.formData
        const options = {
          merchantId: baseInfo.shop,
          categoryId: baseInfo.categoryId
        }
        this.$refs.BiantiRef.fetchGuige(options)
      } catch (error) {
        console.log(error)
      }
    },
    getApiPayload() {
      try {
        this.getFormData()
        const { baseInfo, wuliu, leimu, laiyuan, bianti } = this.formData

        const attrList = JSON.parse(JSON.stringify(this.categoryAttrList))
        const attrJson = attrList
          .map((item) => {
            const attributeId = item.attributeId
            const attributeKey = item.originalAttributeName
            const attributeValue = leimu[attributeKey]
            if (Array.isArray(attributeValue)) {
              return {
                attribute_id: attributeId,
                attribute_value_list: attributeValue.map((value) => {
                  if (typeof value === 'string') {
                    return {
                      value_id: 0,
                      original_value_name: value
                    }
                  } else {
                    return {
                      value_id: value.valueId,
                      original_value_name: value.originalValueName
                    }
                  }
                })
              }
            } else if (typeof attributeValue === 'string') {
              return {
                attribute_id: attributeId,
                attribute_value_list: [
                  {
                    value_id: 0,
                    original_value_name: attributeValue
                  }
                ]
              }
            } else {
              return {
                attribute_id: attributeId,
                attribute_value_list: [
                  {
                    value_id: attributeValue.valueId,
                    original_value_name: attributeValue.originalValueName
                  }
                ]
              }
            }
          })
          .filter(
            (item) =>
              item.attribute_value_list.length !== 0 &&
              item.attribute_value_list.every((key) => key.original_value_name)
          )

        const tierVariationJson = bianti.variantList.map((item) => {
          const temporary = {
            variation_id: 0,
            variation_name: '',
            variation_group_id: 0,
            variation_option_list: [
              {
                variation_option_id: 0,
                variation_option_name: ''
              }
            ]
          }
          if (typeof item.label === 'string') {
            temporary.variation_name = item.label
          } else {
            temporary.variation_id = item.label.id
            temporary.variation_name = item.label.name
            temporary.variation_group_id = item.group.id
          }

          temporary.variation_option_list = item.options.map((option) => {
            if (typeof option === 'string') {
              return {
                variation_option_name: option,
                variation_option_id: 0
              }
            } else {
              return {
                variation_option_name: option.name,
                variation_option_id: option.id,
                image_id: option.imgUrl ? option.imgUrl.split('file/')[1] : ''
              }
            }
          })
          return temporary
        })

        const shopeeGlobalProductSku = bianti.guigeTableData.map((item) => {
          const temporary = {
            originalPrice: item.price,
            sellerStockJsonArray: [
              {
                stock: item.stock
              }
            ],
            globalModelSku: item.sku,
            tierCount: bianti.variantList.length,
            tierIndexX: item.idx,
            tierIndexY: item.idy,
            tierIndex:
              bianti.variantList.length === 1
                ? `[${item.idx}]`
                : `[${item.idx},${item.idy}]`
          }
          return temporary
        })

        const payload = {
          shopeeGlobalProduct: {
            companyId: this.roleInfo.company_id,
            staffId: this.roleInfo.rid,
            hasVariant: bianti.hasVariant,
            merchantId: baseInfo.shop,
            categoryId: baseInfo.categoryId,
            globalItemName: baseInfo.name,
            description: baseInfo.desc,
            globalItemSku: baseInfo.sku,
            imageIds: [...this.imgList],
            originalPrice: bianti.hasVariant
              ? bianti.guigeTableData[0].price
              : bianti.price,
            stock: bianti.hasVariant
              ? bianti.guigeTableData[0].stock
              : bianti.stock,
            weight: wuliu.weight,
            packageLength: wuliu.depth,
            packageWidth: wuliu.width,
            packageHeight: wuliu.height,
            daysToShip: wuliu.day,
            condition: wuliu.shopStatus,
            brandId: 0,
            attributesJsonArray: attrJson,
            descriptionType: 'normal',
            remark: laiyuan.remark,
            sourceLinkList: laiyuan.sourceLink,
            completeness: 0
          },
          shopeeGlobalProductVariation: {
            tierVariationJsonArray: tierVariationJson
          },
          shopeeGlobalProductSkuList: shopeeGlobalProductSku
        }

        return payload
      } catch (error) {
        console.log(error)
      }
    },
    // saveAndSubmit 1.保存  2.保存并发布
    async onSubmit(saveAndSubmit) {
      try {
        this.loadingStatus = true
        const payload = {
          ...this.getApiPayload(),
          saveAndSubmit
        }

        if (this.editId && ['edit', 'update'].includes(this.operateType)) {
          payload.shopeeGlobalProduct.id = this.editId
          if (this.operateType === 'update') {
            // 只有更新需要这个字段
            payload.shopeeGlobalProduct.globalItemId = this.globalItemId
          }
          this.$emit('editSubmit', { ...payload })
          return
        }

        const url = Baseurl + '/shopeeGlobalProductInfo/insertGlobalProduct'
        const res = await ajaxPost(url, payload)
        this.loadingStatus = false
        const { code, message } = res.data
        if (code === 200) {
          this.onClose()
          this.$message.success('操作成功')
        } else {
          this.$message.error(message)
        }
      } catch (error) {
        console.log(error)
        this.loadingStatus = false
      }
    }
  }
}
</script>
